import { render, staticRenderFns } from "./WebBottom.vue?vue&type=template&id=39be7adb&scoped=true"
import script from "./WebBottom.vue?vue&type=script&lang=js"
export * from "./WebBottom.vue?vue&type=script&lang=js"
import style0 from "./WebBottom.vue?vue&type=style&index=0&id=39be7adb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39be7adb",
  null
  
)

export default component.exports